import {contrastRatio, isBrandColor, readableForegroundFor, UI_GRAPHIC_CONTRAST_FLOOR} from "account/brand/brandColors";
import type {PersonalizationDraftState, PersonalizationInherited} from "./personalizationDraft";

/** Clearing a transfer's override restores the account's accent, not the product default. */
export function effectivePersonalizationAccent(
	draft: Pick<PersonalizationDraftState, "accentColor">,
	inherited: Pick<PersonalizationInherited, "accentColor">,
): string | null {
	return draft.accentColor ?? inherited.accentColor;
}

/**
 * Unsaved composer colors only. Persisted recipients keep the server's onAccentColor;
 * this uses the existing preview mirror and never adds a foreground to the wire payload.
 * Absent values let each surface retain its themed product defaults.
 */
export function previewPersonalizationAccent(accentColor: string | null) {
	return {
		accent: accentColor ?? undefined,
		inkOnAccent: accentColor === null ? undefined : readableForegroundFor(accentColor),
	};
}

/**
 * The upload ring's arc colour (owner decision 2026-09-25, kitecorp/transferify-ui#2888). `accent` is
 * {@link effectivePersonalizationAccent}'s answer, so the order is this transfer's colour, then the
 * account's own, then `primary`, the app's. `primary` also wins when the chosen colour would not stand
 * out on the card it is drawn on (`surface`, under 3:1): a progress ring the sender cannot see is no
 * progress ring.
 */
export function progressArcColor(accent: string | null, primary: string, surface: string): string {
	return accent !== null && isBrandColor(accent) && contrastRatio(accent, surface) >= UI_GRAPHIC_CONTRAST_FLOOR
		? accent : primary;
}
